/**
 * AutoSubmit
 * Automatically submit the parent form on change
 */
class AutoSubmit {

    /**
     * @class AutoSubmit
     * @constructor
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {

        this._element = element;
        this._options = options;

        this._timeoutId = null;

        if (this._element.tagName.toLowerCase() === 'form') {
            this._form = this._element;
        } else if (this._options.form) {
            this._form = document.getElementById(this._options.form);
        } else {
            throw new Error('Please provide a `form` id when you`re not initializing on a <form> element');
        }

        this._initialize();

    }

    /**
     * Initialization method
     * @method _initialize
     * @private
     */
    _initialize() {

        this._onChangeBind = () => this._onChange();

        this._element.addEventListener('change', this._onChangeBind);
        this._element.addEventListener('keydown', this._onChangeBind);

    }

    /**
     * Handles form submitting when a change event occurs
     * @private
     */
    _onChange() {

        if (this._options.delay) {
            clearTimeout(this._timeoutId);
            this._timeoutId = setTimeout(() => this._form.submit(), this._options.delay);
        } else {
            this._form.submit();
        }

    }

    /**
     * Unload and reset everything if conditions no longer apply.
     * @method unload
     * @public
     */
    unload() {

        this._element.removeEventListener('change', this._onChangeBind);
        this._element.removeEventListener('keydown', this._onChangeBind);

    }

}

export default AutoSubmit;
